import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e2d92df6&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=e2d92df6&lang=less"
import style1 from "./detail.vue?vue&type=style&index=1&id=e2d92df6&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d92df6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2d92df6')) {
      api.createRecord('e2d92df6', component.options)
    } else {
      api.reload('e2d92df6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e2d92df6&scoped=true", function () {
      api.rerender('e2d92df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/audit/detail.vue"
export default component.exports